import { UserInfo } from '@/components/UserInfo';
import { Menu, PenBoxIcon, X } from 'lucide-react';
import { useChatActions, useChatHistory } from '../context/ChatContext';
import { useTutorial } from '@/features/onboarding/useTutorial';

export const ChatHeader = () => {
  // Narrow subscriptions: the header's menu button has nothing to do with
  // typing or streaming, so it shouldn't re-render for either.
  const { isSidebarCollapsed } = useChatHistory();
  const { toggleSidebar, startNewConversation } = useChatActions();
  // The tutorial overlay is a full-viewport layer with no pointer-events
  // carve-out (see TutorialOverlay.tsx) — it visually and functionally
  // covers this button on every step, not just the one that targets the
  // sidebar's own "New chat" button. Hiding it while the tutorial runs
  // avoids a button that looks tappable but silently isn't.
  const { isActive: isTutorialActive } = useTutorial();

  return (
    <header className="relative flex flex-shrink-0 items-center justify-between bg-white px-4 py-2 md:px-6 ">
      <div className="flex items-center gap-1 md:w-auto">
        <button
          type="button"
          className="md:hidden inline-flex items-center justify-center rounded-full p-2 text-slate-600 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
          onClick={toggleSidebar}
          aria-label={isSidebarCollapsed ? 'Open menu' : 'Close menu'}
        >
          {isSidebarCollapsed ? <Menu className="h-5 w-5" /> : <X className="h-5 w-5" />}
        </button>
        {!isTutorialActive && (
          <button
            type="button"
            className="md:hidden inline-flex items-center justify-center rounded-full p-2 text-slate-600 hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
            onClick={startNewConversation}
            aria-label="New chat"
          >
            <PenBoxIcon className="h-5 w-5" />
          </button>
        )}
        <img
          src="./mascot-hand-horizontal.gif"
          alt="Phytobiotics Logo"
          className="hidden h-8 shrink-0 md:block md:h-16"
        />
      </div>

      <img
        src="./mascot-hand-horizontal.gif"
        alt="Phytobiotics Logo"
        className="absolute left-1/2 top-1/2 h-7 shrink-0 -translate-x-1/2 -translate-y-1/2 md:hidden"
      />

      <div className="flex min-w-0 items-center">
        <UserInfo />
      </div>
    </header>
  );
};
